// import axios from '@/plugin/axios.js'
const state = {
  // 通信框架

}
export default state



// WEBPACK FOOTER //
// ./src/store/state.js